import {Anchor, Box, Button, Group, Paper, Stack, Text, Title, useComputedColorScheme} from "@mantine/core";
import {Calendar, ChevronRight, Info} from "lucide-react";
import {useTranslation} from "react-i18next";
import {useState} from "react";
import {useLocation} from "wouter";
import {Heatmap} from "@mantine/charts";

const CalendarStatus = ({status, user, repo}) => {
    const {t} = useTranslation();
    const [selectedYear, setSelectedYear] = useState(2026);
    const [location, setLocation] = useLocation();

    const handleClick = (date) => {
        setLocation(`/verification/${user}/${repo}/${date}`);
        }

    var years = [];

    if (!status) {
        return null;
        }

    (Object.entries(status)).forEach(([key, value], index) => {
        var year = key.split('-')[0];
        if (!years.includes(year)) {
            years.push(year);
            }
        });
    console.log(years);

    return  <Stack gap="md">
                <Group gap="xs">
                  <Calendar size={18} />
                  <Title order={2} fz="lg" fw={700} tt="uppercase">
                    {t('Detailed Coverage Timeline')}
                  </Title>
                </Group>

                <Paper radius="lg" p="lg" withBorder>
                  <Stack gap="md">

                    <YearSelection years={years} selectedYear={selectedYear} onYearSelected={setSelectedYear} />
                    <CalendarView data={status} year={selectedYear} onClick={handleClick} />

                    <Group justify="space-between" align="center">
                      <Group gap={6}>
                        <Info size={14} />
                        <Text fz="xs" c="dimmed">
                          {t('Each active square represents a day where commits were anchored to Bitcoin.')}
                        </Text>
                      </Group>
                    </Group>
                  </Stack>
                </Paper>
              </Stack>;
    }

const YearSelection = ({years, selectedYear, onYearSelected}) => {

    const yearOptions = years.map((year) => {
        return <YearOption key={year} year={year} selectedYear={selectedYear} onYearSelected={onYearSelected}/>;
        })

    return <Group gap="sm">
              {yearOptions}
            </Group>;
    }

const YearOption = ({year, selectedYear, onYearSelected}) => {
    const handleSelected = () => {
        onYearSelected(year);
        }
    return <Button
                  size="xs"
                  variant={selectedYear === year ? 'filled' : 'default'}
                  onClick={handleSelected}
                  >
                  {year}
                </Button>;
    }

const CalendarView = ({data, year, onClick}) => {
     const startDate = `${year}-01-01`;
     const endDate = `${year}-12-31`;

     const colorScheme = useComputedColorScheme('dark');
     const labelColor = colorScheme === 'dark'
                                    ? 'var(--mantine-color-gray-4)'
                                    : 'var(--mantine-color-gray-7)';
     const levelColor = {
        0: colorScheme === 'dark' ? '#1A1B1E' : '#ffffff',
        1: colorScheme === 'dark' ? '#0E4429' : '#9be9a8',
        2: colorScheme === 'dark' ? '#006D32' : '#40c463',
        3: colorScheme === 'dark' ? '#26A641' : '#30a14e',
        4: colorScheme === 'dark' ? '#39D353' : '#216e39',
        };

     return <Heatmap
                    data={data}
                    startDate={startDate}
                    endDate={endDate}
                    rectSize={16}
                    gap={3}
                    withTooltip
                    withWeekdayLabels
                    withMonthLabels
                    xcolors={levelColor}
                    colors={ [
                        levelColor[0], levelColor[1], levelColor[2],levelColor[3], levelColor[4]
                        ]}
                    styles={{
                        weekdayLabel: { fill: labelColor },
                        monthLabel: { fill: labelColor },
                        }}
                    getTooltipLabel={({ date, value }) => `${date}`}
                    getRectProps={({date, value}) => {
                        const props = {
                            onClick: () => {
                                if (value) {
                                    onClick(date);
                                }
                            },
                            stroke: colorScheme === 'dark' ? '#2C2E33' : '#e0e0e0',
                            strokeWidth: 0.5,
                            style: { cursor: 'pointer' }
                        };
                        if (!value) {
                            props.fill = colorScheme === 'dark' ? '#1A1B1E' : '#f5f5f5';
                        }
                        return props;
                    }}
                    />;
     }


export default CalendarStatus;